import { render, staticRenderFns } from "./BasicBarGraph.vue?vue&type=template&id=235e06e5&"
import script from "./BasicBarGraph.vue?vue&type=script&lang=js&"
export * from "./BasicBarGraph.vue?vue&type=script&lang=js&"
import style0 from "./BasicBarGraph.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports